import { memo } from 'react'
import classNames from 'classnames'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { Dropdown } from 'ui_kit_qmd'
import './optionTile.scss'
import selectedOptionIcon from '../../../../../../images/common/option.svg'
import { type Option } from '../../../../../../types/products/productTypes'
import { useProductOrderContext } from '../../../../context'
import { selectAsyncRefillsPhase1Flag } from 'store/flags/FlagsSelectors'
import { useSelector } from 'store/hooks/useSelector'

interface Props {
  option: Option
}

const DEFAULT_MHT_ALLOWED_REFILLS_REFILLS_REFILLS_QUANTITY = 0
const DEFAULT_NON_MHT_ALLOWED_REFILLS_REFILLS_QUANTITY = 5

export const OptionTile = memo(({ option }: Props) => {
  const {
    isPatientRefillAllowed,
    refillsQuantity,
    resetRefillsQuantity,
    selectedOption,
    setRefillsQuantity,
    setSelectedOption,
    isMHTPharmacyPickup,
    isMoudPharmacyPickup,
    isMHTHomeDelivery,
    isMHT,
  } = useProductOrderContext()
  const { DurationDisplay, IsRefillAllowed: isProductRefillAllowed, OptionId, Price, ShortName } = option
  const formattedPrice = `$${Number(Price).toLocaleString('en-US', {
    minimumFractionDigits: 2,
  })}`

  const isSelected = selectedOption?.OptionId === OptionId
  const isPharmacyPickup = isMoudPharmacyPickup || isMHTPharmacyPickup

  // Refills are allowed in two cases:
  // 1) Pharmacy pickup for non-MHT products when both the product and patient allow refills.
  // 2) Any MHT home delivery order if the async refills phase 1 flag is enabled.
  const asyncRefillsPhase1IsEnabled = useSelector(selectAsyncRefillsPhase1Flag)

  const isRefillAllowed =
    (isPharmacyPickup && isProductRefillAllowed && isPatientRefillAllowed && !isMHT) ||
    (isMHTHomeDelivery && asyncRefillsPhase1IsEnabled)

  const showRefillsDropdown = isRefillAllowed && isSelected

  function handleOnClick() {
    if (isSelected) {
      return
    }

    setSelectedOption(option)

    if (isMHTHomeDelivery) {
      setRefillsQuantity(DEFAULT_MHT_ALLOWED_REFILLS_REFILLS_REFILLS_QUANTITY)
    } else if (isRefillAllowed) {
      setRefillsQuantity(DEFAULT_NON_MHT_ALLOWED_REFILLS_REFILLS_QUANTITY)
    } else {
      resetRefillsQuantity()
    }
  }
  return (
    <div
      className={classNames('dose-tile-container', { 'is-selected': isSelected })}
      role='presentation'
      onClick={handleOnClick}>
      <div className='dose-tile-top-content'>
        <div className='dose-tile-info-container'>
          <div className='dose-tile-text bold'>{ShortName}</div>

          {Price && !isPharmacyPickup ?
            <div className='dose-tile-text'>{formattedPrice}</div>
          : null}

          <div className='dose-tile-text dose-tile-note'>{DurationDisplay}</div>
        </div>

        {isSelected ?
          <img className='dose-tile-selected-icon' src={selectedOptionIcon} alt={`Select ${ShortName}`} />
        : <div className='dose-tile-unselected-icon' />}
      </div>

      {showRefillsDropdown ? <Dropdown
          dropId='refills-dropdown-'
          label='Refills'
          options={[0, 1, 2, 3, 4, 5]}
          containerStyle={{ width: '120px' }}
          dropdownContainerStyle={{ height: 'auto' }}
          setValue={setRefillsQuantity}
          // !! Can't just pass in the value here since 0 is falsy, and it seems the dropdown component does a falsy
          // check in the value to see whether to apply specific styles to the label if there is no value provided
          value={String(refillsQuantity)}
        /> : null}
    </div>
  )
})
